import { IProductOptionData } from "common/records/ProductOption";
import { IProductOptionGroupData } from "common/records/ProductOptionGroup";
import { ActionsUnion, createAction } from "common/reducers/UtilsTypes";
import { IdType } from "common/types";
import { List } from "immutable";

export const FETCH_PRODUCT_OPTION_GROUP = "@productOptionGroups/FETCH_PRODUCT_OPTION_GROUP";
export const RECEIVE_PRODUCT_OPTION_GROUP = "@productOptionGroups/RECEIVE_PRODUCT_OPTION_GROUP";
export const RECEIVE_PRODUCT_OPTION_GROUPS = "@productOptionGroups/RECEIVE_PRODUCT_OPTION_GROUPS";

export const ProductOptionGroupActions = {
  fetchProductOptionGroup: (productOptionGroupId: number) =>
    createAction(FETCH_PRODUCT_OPTION_GROUP, { productOptionGroupId }),
  receiveProductOptionGroup: (productOptionGroup: Partial<IProductOptionGroupData>) =>
    createAction(RECEIVE_PRODUCT_OPTION_GROUP, { productOptionGroup }),
  receiveProductOptionGroups: (productOptionGroups: IProductOptionGroupData[]) =>
    createAction(RECEIVE_PRODUCT_OPTION_GROUPS, { productOptionGroups }),
};

export type ProductOptionGroupActions = ActionsUnion<typeof ProductOptionGroupActions>;
